import styled from 'styled-components'
import {
  lightBlue,
  paleGray,
  lightSilver,
  white,
  darkSlateBlue
} from '../../../styles/settings/colors'
import { txt16OpenSans } from '../../../styles/settings/types'

export const Container = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 60px;
  display: flex;
  background-color: ${props => (props.checked ? lightBlue : paleGray)};
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
export const SwitchContainer = styled.div`
  user-select: none;
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${paleGray};
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 13px;
    width: 13px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: ${darkSlateBlue};
  }

  input:focus + .slider {
    box-shadow: 0 0 1px ${darkSlateBlue};
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(13px);
    -ms-transform: translateX(13px);
    transform: translateX(13px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 17px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
`

export const Text = styled.span`
  ${txt16OpenSans};
  font-weight: bold;
  text-align: center;
  color: ${props => (props.checked ? white : lightSilver)};
`

export const Slider = styled.span``

export const Label = styled.label`
  user-select: none;
  margin-left: 40px;
`

export const Input = styled.input`
  display: none;
`



// WEBPACK FOOTER //
// ./src/app/elements/ToggleSwitch/styles.js